import { useAccount, useNetwork, useSwitchNetwork } from "wagmi";
import Button from "../Button/Button";

const WrongChainBanner: React.FC = () => {
  const { isConnected } = useAccount();
  const { chain } = useNetwork();
  const { switchNetwork } = useSwitchNetwork();

  if (!isConnected) return <div />;

  if (chain && chain?.id === 1) return <div />;

  return (
    <div className="bg-dark-100">
      <div className="mx-auto px-3 py-3 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex w-0 flex-1 items-center">
            <p className="ml-3 truncate font-medium text-white">
              <span className="inline md:hidden">Wrong network</span>
              <span className="hidden md:block">
                You are connected to the wrong network
              </span>
            </p>
          </div>
          <div className="order-2 mt-0 w-auto flex-shrink-0">
            <Button onClick={() => switchNetwork?.(1)}>
              Switch to Mainnet
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WrongChainBanner;
